export default __webpack_public_path__ + "static/media/about-sec-img.8a302d62.png";